'use client';
import { useFlag } from '@mentimeter/flags/confidence/client';
import FullColorBlock from '../FullColorBlock';
import CardsBlock from '../CardsBlock';
import { useHomepageData } from './useHomepageData';
import Hero from './Hero';
import EditorExperienceBlock from './EditorExperienceBlock';
import DesktopImageBlock from './DesktopImageBlock';
import HalfColorBlock from './HalfColorBlock';
import type { CompanyRoleGroup } from './executiveRoles';

export const Content = ({
  workRoleGroup,
  isAuthenticated,
}: {
  workRoleGroup: CompanyRoleGroup;
  isAuthenticated: boolean;
}) => {
  const { value: isHomePagePersonalizedHeaderActivated } = useFlag(
    'og-homepage-personalized-header.enabled',
    false,
  );

  const currentRoleGroup = isHomePagePersonalizedHeaderActivated
    ? workRoleGroup
    : 'default';

  const {
    heroData,
    desktopImageBlockData,
    cardsData,
    halfColorData,
    fullColorBlockData,
  } = useHomepageData(currentRoleGroup, isAuthenticated);
  return (
    <>
      <Hero
        {...heroData}
        isAuthenticated={isAuthenticated}
        roleGroup={currentRoleGroup}
      />
      <EditorExperienceBlock />
      <DesktopImageBlock {...desktopImageBlockData} />
      <CardsBlock {...cardsData} />
      {halfColorData.map((data, i) => (
        <HalfColorBlock key={data.info.title + i} {...data} />
      ))}
      <FullColorBlock {...fullColorBlockData} />
    </>
  );
};
